import SectionRecord from "models/view-models/section-record";
import { UseSectionPreviewValue } from "organisms/checklist-item-notes/hooks/use-section-preview-value";
import { useState, useEffect } from "react";

export const useSingleSectionPreview = (
    availableSections?: SectionRecord[]
): UseSectionPreviewValue => {
    const [previewingSection, setPreviewingSection] =
        useState<SectionRecord | null>(null);

    const previewSection = (section: SectionRecord): void => {
        setPreviewingSection(section);
    };

    const removeSectionPreview = (): void => {
        setPreviewingSection(null);
    };

    useEffect(() => {
        if (
            previewingSection != null &&
            Array.isArray(availableSections) &&
            !availableSections.some((s) => s.id === previewingSection.id)
        ) {
            setPreviewingSection(null);
        }
    }, [availableSections, previewingSection]);

    const toggleSectionPreview = (section: SectionRecord) => {
        if (previewingSection?.id === section.id) {
            removeSectionPreview();
        } else {
            previewSection(section);
        }
    };

    return {
        previewingSections:
            previewingSection == null ? [] : [previewingSection],
        previewSection: previewSection,
        removeSectionPreview: removeSectionPreview,
        toggleSectionPreview: toggleSectionPreview,
    };
};
